var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "warning (1) 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M40 28.785C38.7575 28.785 37.75 29.7925 37.75 31.035V46.5925C37.75 47.835 38.7575 48.8425 40 48.8425C41.2425 48.8425 42.25 47.835 42.25 46.5925V31.035C42.25 29.7925 41.2425 28.785 40 28.785Z",
    fill: "#F98A17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M40 52.6375C38.7575 52.6375 37.75 53.645 37.75 54.8875V56.2625C37.75 57.505 38.7575 58.5125 40 58.5125C41.2425 58.5125 42.25 57.505 42.25 56.2625V54.8875C42.25 53.645 41.2425 52.6375 40 52.6375Z",
    fill: "#F98A17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M73.5088 56.505L46.7213 14.845C45.2438 12.55 42.7288 11.1775 39.9963 11.1775C37.2638 11.1775 34.7488 12.55 33.2713 14.8475L6.48376 56.505C4.87626 59.0025 4.76626 62.0525 6.19126 64.6625C7.61376 67.27 10.2388 68.8275 13.2113 68.8275H66.7863C69.7563 68.8275 72.3813 67.27 73.8063 64.6625C75.2263 62.05 75.1163 59.0025 73.5088 56.505ZM69.8513 62.5025C69.2288 63.645 68.0813 64.325 66.7813 64.325H13.2088C11.9088 64.325 10.7613 63.6475 10.1388 62.5025C9.51626 61.3625 9.56376 60.03 10.2663 58.935L37.0538 17.28C38.3663 15.245 41.6238 15.245 42.9388 17.28L69.7263 58.935C70.4288 60.03 70.4738 61.3625 69.8513 62.5025Z",
    fill: "#F98A17"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.f184b0bf9f38993b8bac2ab2b2660878.svg";
export { ForwardRef as ReactComponent };